import { Component, HostListener, Input, OnInit } from '@angular/core';
import { NavigationItem } from '../../models/navigation-item-model';
import { Router } from '@angular/router';
import { LabelService } from '../../services/label.service';
import { TokenService } from '../../services/token.service';
import { labelsWithBottomSeparator } from '../labels';

@Component({
  selector: 'app-side-top-bar',
  standalone: false,
  // imports: [],
  templateUrl: './side-top-bar.component.html',
  styleUrl: './side-top-bar.component.scss',
})
export class SideTopBarComponent implements OnInit {
  @Input() navigationItems: NavigationItem[] = [];
  showUserPanel = false;
  labelsWithBottomSeparator: string[] = labelsWithBottomSeparator;

  dropdownMenuVisible = false;
  isMobile = window.innerWidth < 930;

  private loggedIn: boolean = false;
  profilePicture: string = '';

  isSideBarSmall = false;

  constructor(
    private router: Router,
    public labelService: LabelService,
    private tokenService: TokenService
  ) {
    this.profilePicture = sessionStorage.getItem('profilePicture') || '';
  }
  ngOnInit(): void {
    const sideBarSmall = sessionStorage.getItem('isSideBarSmall');
    if (sideBarSmall === 'true') {
      this.isSideBarSmall = true;
    } else {
      this.isSideBarSmall = false;
    }
    if (this.isMobile) {
      document.body.style.height = window.innerHeight + 'px';
      this.isSideBarSmall = true;
    }
  }

  navigateToHomePage() {
    this.router.navigate(['/homepage']);
  }

  // FIXME: what types are accepted?
  navigateToCorrectPage(item: any) {
    if (item === 'cookie-policy') {
      window.open(
        'https://www.iubenda.com/privacy-policy/96084129/cookie-policy',
        '_blank'
      );
      return;
    }
    if (item && item.route) {
      this.router.navigate([item.route]);
      return;
    }
    if (item && item.label) {
      item.label = '/' + item.label.toLowerCase();
      item.label = item.label.replaceAll(' ', '-');
      this.router.navigate([item.label]);
    }
    if (item) {
      item = '/' + item.toLowerCase();
      item = item.replaceAll(' ', '-');
      this.router.navigate([item]);
    }
  }

  toggleSideBar() {
    this.isSideBarSmall = !this.isSideBarSmall;
    sessionStorage.setItem('isSideBarSmall', this.isSideBarSmall.toString());
  }

  toggleUserPanel() {
    this.showUserPanel = !this.showUserPanel;
  }

  logout() {
    this.tokenService.clearAllTokens();
    this.router.navigate(['/']);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobile = window.innerWidth < 930;
    this.isSideBarSmall = window.innerWidth < 930;
    document.body.style.height = window.innerHeight + 'px';
  }

  toggleDropdownMenu() {
    this.dropdownMenuVisible = !this.dropdownMenuVisible;
  }
}
